import { Flex } from '@chakra-ui/react'
import React from 'react'
import { VoicemailTranscriptSection } from '~/pages/Calls/CallDetails/sections/VoicemailTranscriptSection'
import { useGetVoicemail } from '~/queries/voicemailQueries'

export type VoicemailToolTipProps = {
  voicemailId: number
  pbxId: number
  callId: number
}

export const VoicemailToolTip = ({ voicemailId }: VoicemailToolTipProps) => {
  const {
    data: voicemail,
    error: voicemailError,
    isLoading: isVoicemailLoading,
  } = useGetVoicemail({
    voicemailId,
    options: {
      enabled: !!voicemailId,
    },
  })

  return (
    <Flex width="25rem">
      <VoicemailTranscriptSection
        voicemail={voicemail}
        voicemailError={voicemailError ?? undefined}
        isVoicemailLoading={isVoicemailLoading}
        isToolTip={true}
      />
    </Flex>
  )
}
